import { AttenceStateEnum } from '@/interfaces/attenceState'
import {SourceTypeEnum,ActionLogTypeEnum,VrtResourceTypeEnum} from '@/interfaces/virtualTeachingAndResearchSectionCommonType'
import i18n from '@/lang'
import { objCookie } from '@/utils/common';
import urlConfig from '@/Configurations/urlConfig';
/**
 * @param {string} str
 * @returns {String}
 * 将富文本转换为普通字符串
 */
export function richtextFilter(str: string): string {
  if (!str) {
    return ''
  }
  let text = str
  // 去除html标签, 图片, 换行, 回车等等
  text = text.replace(/(\n)/g, '')
  text = text.replace(/(\t)/g, '')
  text = text.replace(/(\r)/g, '')
  text = text.replace(/<\/?[^>]*>/g, '')
  text = text.replace(/\s*/g, '')
  return text
}

export function findIndexArray(data: any, id: any, indexArray: []): Array<any>{
  let arr: any = Array.from(indexArray)
  for (let i = 0, len = data.length; i < len; i++) {
    arr.push(data[i].pid)
    if (data[i].id === id) {
      return arr
    }
    let children = data[i].children
    if (children && children.length) {
      let result: any = findIndexArray(children, id, arr)
      if (result && result.length>0) return result
    }
    arr.pop()
  }
  return []
}

/**
 * @param {string} html
 * @returns {String}
 * 将转义的字符串反转为标签
 */
export function unescape(html: string): string {
  if (html == null || html == undefined) {
    return "";
  }
  let tempHtml = html.replace(/\s+|&nbsp;/ig, ' ');
  return tempHtml
    .replace(tempHtml ? /&(?!#?\w+;)/g : /&/g, '&amp;')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&ldquo;/g, '“')
    .replace(/&rdquo;/g, '”')
}

/**
 * @param {Number} Min
 * @param {Number} Max
 * @returns {Number}
 * 输出min ≤ r ≤ max随机数
 */
export function randomNumBoth(Min: number, Max: number): number {
  let Range = Max - Min
  let Rand = Math.random()
  let num = Min + Math.round(Rand * Range) //四舍五入
  return num
}

/**
 * @param {Number} len
 * @returns {String}
 * 获取随机数
 */
export function random_string(lens: number): string {
  let len = lens || 32
  let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  let maxPos = chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  pwd = pwd.toLowerCase()
  return pwd
}

/**
 * @param {Object} parent 父节点
 * @param {Object} children 子节点
 * @param {Object} storage 存储的object, 每个key都是id, value是它的父节点
 * 构建Tree结构的反向索引
 */
export function buildTree(parent: any, children: any, storage: any): void {
  children.forEach((node: any) => {
    if (parent) {
      storage[node.id] = parent
    }
    if (node.children) {
      buildTree(node, node.children, storage)
    }
  })
}

/**
 * @param {String} id
 * @param {Object} storage
 * @returns {Array}
 * 根据某个ID从Tree中寻找路径
 */
export function findPathByNodeID(id: string, storage: any): Array<string> {
  const path = [id]
  let parent = storage[id]
  // if (parent) {
  //   path.push(id)
  // }
  while (parent) {
    path.push(parent.id)
    parent = storage[parent.id]
  }
  return path.reverse()
}

/**
 * @returns {Number}
 * 文档高度
 */
export function getScrollTop(): number {
  let scrollTop = 0,
    bodyScrollTop = 0,
    documentScrollTop = 0
  if (document.body) {
    bodyScrollTop = document.body.scrollTop
  }
  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop
  }
  scrollTop = bodyScrollTop - documentScrollTop > 0 ? bodyScrollTop : documentScrollTop
  return scrollTop
}

/**
 * @returns {Number}
 * 可视窗口高度
 */
export function getWindowHeight(): number {
  let windowHeight = 0
  if (document.compatMode == 'CSS1Compat') {
    // 标准兼容模式开启
    windowHeight = document.documentElement.clientHeight
  } else {
    windowHeight = document.body.clientHeight
  }
  return windowHeight
}

/**
 * @returns {Number}
 * 滚动条高度
 */
export function getScrollHeight(): number {
  let scrollHeight = 0,
    bodyScrollHeight = 0,
    documentScrollHeight = 0
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight
  }
  scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
  return scrollHeight;
}

export function getQueryValue(name: string) {
  if (name == null || name == 'undefined') {
    return null
  }

  var searchStr = decodeURI(location.search)

  var infoIndex = searchStr.indexOf(name + '=')

  if (infoIndex == -1) {
    return null
  }

  var searchInfo = searchStr.substring(infoIndex + name.length + 1)

  var tagIndex = searchInfo.indexOf('&')

  if (tagIndex != -1) {
    searchInfo = searchInfo.substring(0, tagIndex)
  }

  return searchInfo
}

// 手机号校验
export function isPhoneNumber( value:string,callback:any) {
  let reg = /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/;
  if(value==''||value==undefined||value==null){
    callback();
  }else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的电话号码'));
    } else {
      callback();
    }
  }
}

//图片处理
export function getImge(imgSrc:string) {
  let imgUrl=''
  if (process.env.NODE_ENV === 'development') {
    imgUrl = 'https://testopenapi.webtest.ketangpai.com/'+imgSrc
  } else if (process.env.VUE_APP_CURRENTMODE === 'test') {
    imgUrl = 'https://testopenapi.webtest.ketangpai.com/'+imgSrc
  } else if (process.env.NODE_ENV === 'production') {
    imgUrl = 'https://testopenapi.webtest.ketangpai.com/'+imgSrc
  }
  return imgUrl
}

export function toDouble(n:number) {
  if (n < 10) {
    return '0' + n;
  } else {
    return '' + n;
  }
}
//转为1位数
export function toSingle (n:number) {
  return n < 10 ? Number(n) : n;
};

export function time_format_year_month_day_hour_min(unixTime:number) {
  var time = new Date(unixTime * 1000);
  var ymdhis = "";
  ymdhis += (time.getFullYear() + "").substring(2) + "-";
  ymdhis += toDouble((time.getMonth() + 1)) + "-";
  ymdhis += toDouble(time.getDate()) + " ";
  ymdhis += toDouble(time.getHours()) + ":";
  ymdhis += toDouble((time.getMinutes()));
  return ymdhis;
};

//时间格式的处理
export function getDateDiff(dateTimeStamp: number): string {
  if (dateTimeStamp == 0) {
    return ''
  }
  let minute = 60;
  let hour = minute * 60;
  let day = hour * 24;
  let halfamonth = day * 15;
  let month = day * 30;

  let now = new Date().getTime()
  let diffValue = now - dateTimeStamp
  if(diffValue < 0){
    return ''
  }
  let monthC:number = diffValue/month
  let weekC:number = diffValue/(7*day)
  let dayC:number = diffValue/day
  let hourC:number = diffValue/hour
  let minC:number = diffValue/minute
  let result:string = ''
  if(monthC>=1){
    result = time_format_year_month_day_hour_min(dateTimeStamp);
  }
  else if(weekC>=1){
    result = time_format_year_month_day_hour_min(dateTimeStamp);
  }
  else if(dayC>=1){
    result = time_format_year_month_day_hour_min(dateTimeStamp);
  }
  else if(hourC>=1){
    result = hourC +"个小时前";
  }
  else if(minC>=1){
    result = minC +"分钟前";
  }else if(dateTimeStamp<60){
    result = dateTimeStamp+'秒前'
  }else if(dateTimeStamp<3){
    result = '刚刚'
  }
    return result;
}

// 将时长处理为 00:00:00的格式
export function formatDuration(a: number): string {
  // @ts-ignore
  let hh = parseInt(a/3600);
  // @ts-ignore
  if(hh<10) hh = "0" + hh;
  // @ts-ignore
  let mm = parseInt((a-hh*3600)/60);
  // @ts-ignore
  if(mm<10) mm = "0" + mm;
  // @ts-ignore
  let ss = parseInt((a-hh*3600)%60);
  // @ts-ignore
  if(ss<10) ss = "0" + ss;
  var length = hh + ":" + mm + ":" + ss;
  if(a>0){
    return length;
  }else{
    return "NaN";
  }
}

export function handleUrlProtocal(url=''): string {
  if (url.startsWith('http')) return url
  return `http://${url}`
}

// 存储folderPath
export function  storeFolderPath(folderpath: Array<{id: string, name: string}>) {
  const folderPath = JSON.stringify(folderpath)
  sessionStorage.setItem('curFolderPath', folderPath)
}

// 获取folderPath
export function  getFolderPath(): Array<{id: string, name: string}> {
  if (!sessionStorage.getItem('curFolderPath')) {
    return []
  }
  const folderPath = JSON.parse(sessionStorage.getItem('curFolderPath') as string)
  return folderPath
}

export function isVideo(ext:string){
  if(ext == undefined || ext == null || ext == ""){
    return false;
  }
  let extTypeArray = [
      'mp4' ,
      'flv' ,
      'mov' ,
      'rm' ,
      'rmvb' ,
      'avi' ,
      '3gp' ,
      'wmv' ,
      'mkv' ,
      'ts' ,
      'webm' ,
      'm3u8' ,
      'mpg' ,
      'asf' ,
  ];
  for(let i=0;i<extTypeArray.length;i++){
    if(extTypeArray[i] == ext.toLowerCase()){
      return true;
    }
  }
  return false;
}
//判断是不是演示的账号
export function isDemoAccount(uid:string){
  if(uid == 'MDAwMDAwMDAwMLSsvaE' || uid == '76'){
    return true;
  }
  if(uid == 'MDAwMDAwMDAwMLOGrdw' || uid == '121'){
    return true;
  }
  return false;
}

//获取URL链接里面的参数
export function getUrlQuery(paraName:string) {
  var url = document.location.toString();
  var arrObj = url.split("?");
  if (arrObj.length > 1) {
      var arrPara = arrObj[1].split("&");
      var arr;
      for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");
          if (arr != null && arr[0] == paraName) {
              return arr[1];
          }
      }
      return null;
  }
  else {
      return null;
  }
}

//获取URL链接里面的参数，处理hash模式
export function getUrlQueryUseHash(paraName: string,locationHref:string="") {
  let url = document.location.toString();
  if(locationHref && locationHref.length>0){
    url = locationHref;
  }
  let arrObj = url.split("?");
  if (arrObj.length > 1) {
    let arrPara = arrObj[1].split("&");
    let arr;
    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return null;
  }
  return null;
}
//参数URL里面的参数
export function delUrlQuery(url: string, paramKey: string) {
  let beforeUrl = url.substr(0, url.indexOf("?"));   //?之前主地址
  let afterUrl = url.substr(url.indexOf("?") + 1);   //？之后参数路径
  let nextUrl = "";
  let arr = new Array();
  if (afterUrl != "") {
    let urlParamArr = afterUrl.split("&"); //将参数按照&符分成数组
    for (let i = 0; i < urlParamArr.length; i++) {
      let paramArr = urlParamArr[i].split("="); //将参数键，值拆开
      //如果键雨要删除的不一致，则加入到参数中
      if (paramArr[0] !== paramKey) {
        arr.push(urlParamArr[i]);
      }
    }
  }
  if (arr.length > 0) {
    nextUrl = "?" + arr.join("&");
  }
  url = beforeUrl + nextUrl;
  return url;
}
//改变url里面的参数
export function changeURLArg(url:string, arg:any, arg_val:any) {
  let beforeUrl = url.substr(0, url.indexOf("?"));   //?之前主地址
  let afterUrl = url.substr(url.indexOf("?") + 1);   //？之后参数路径
  let nextUrl = "";
  let arr = new Array();
  if (afterUrl != "") {
      let urlParamArr = afterUrl.split("&"); //将参数按照&符分成数组
      for (let i = 0; i < urlParamArr.length; i++) {
          let paramArr = urlParamArr[i].split("="); //将参数键，值拆开
          //如果键雨要删除的不一致，则加入到参数中
          if (paramArr[0] !== arg) {
              arr.push(urlParamArr[i]);
          }else { //找到要修改的部分
              let newVal = arg+"="+arg_val;
              arr.push(newVal);
          }
      }
  }
  if (arr.length > 0) {
      nextUrl = "?" + arr.join("&");
  }
  url = beforeUrl + nextUrl;
  return url;
}
//设置url的参数
export function setUrlQuery(key:string, name:string) {
  if ('pushState' in history) {
    let oldUrl = location.href;
    let nUrl = "";
    if(name == null || name == "" || name.length == 0){
      nUrl = delUrlQuery(oldUrl,key);
    }else{
      nUrl = changeURLArg(oldUrl, key, name);
    }
    let state = {title: '', url: nUrl};
    window.history.replaceState(state, '', nUrl);
  }
}

//通过参数里面的token来进行登录
export function usePathTokenTologin(){
    //判断路由地址
    const urlCache = window.location.href;
    if(urlCache!=null && (urlCache.indexOf("/courseHome?")>=0 || urlCache.indexOf("/ktpCourse?")>=0 || urlCache.indexOf("/courseInfo?")>=0)){
      let xtoken = getUrlQuery('xktptoken');
      //通过外部传进来的token值，要进行处理
      if(xtoken != null && xtoken.length>0){
        window.localStorage.setItem('token',xtoken);
        setUrlQuery('xktptoken',"");
        //这里要进行弹窗提醒，当前处于督导模式，拥有和老师一样的权限，请勿对老师的数据进行操作
        return true;
      }
    }
    return false;
}

//判断是不是有学生视角的参数
export function isStudentViewer(){
  let studentviewer = getUrlQueryUseHash('studentviewer');
  if(studentviewer == "1"){
    return true;
  }
  return false;
}
//判断是不是督导视角
export function isSupervise(){
  let supervise = getUrlQueryUseHash('supervise');
  if(supervise == "1"){
    return true;
  }
  return false;
}
//判断是不是移动端设备
export function isMobileDevice(): boolean {
  let ua = window.navigator.userAgent;
  return /(iphone|ios|android|mini|mobile|mobi|Nokia|Symbian|iPod|iPad|Windows\s+Phone|MQQBrowser|wp7|wp8|UCBrowser7|UCWEB|360\s+Aphone\s+Browser)/i.test(ua);
}

//设置icon
export function makeIcon(href: any) {
  var link = document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = href;
  document.getElementsByTagName('head')[0].appendChild(link);
}

//获取院校的配置
export function getSchoolConfig(){
  let schoolConfigStr = window.localStorage.getItem('schoolConfig') as string;
  if(schoolConfigStr!=null && schoolConfigStr.length>0){
    let schoolConfigObj = JSON.parse(schoolConfigStr);
    return schoolConfigObj;
  }
  return null;
}
//获取是否配置个性化域名的部分
export function getMobilexdomain(){
  let mobilexdomain = getUrlQuery('mobilexdomain');
  if(mobilexdomain==null || mobilexdomain == ""){
    let schoolConfigObj = getSchoolConfig();
    if(schoolConfigObj){
      return schoolConfigObj['key_name'];
    }
  }else{
    return mobilexdomain;
  }
  return "";
}

// 最多显示字数
export function filterLimitWords(text: string, length: number = 10) {
  const str = String(text);
  if(str.length > length) {
    return str.slice(0, length) + '...';
  } else {
    return text;
  }

}

//判断是否是数字
export function isNumber(val:any) {
  var regPos = /^\d+(\.\d+)?$/; //非负浮点数
  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
  if(regPos.test(val) || regNeg.test(val)) {
      return true;
  } else {
      return false;
  }
}

//判断是不是图片
export function isPic(type: string) {
  if (type == null || type == "") {
    return false;
  }
  let tmpType = type.toLowerCase();
  if(tmpType == "png" || tmpType == "jpeg" || tmpType == "jpg" || tmpType == "gif" || tmpType == "bmp"){
    return true;
  }
  return false;
}

export function getBytes(str: string) {
  let len = str.length;
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 255) {
      len++;
    }
  }
  return len;
}

/**
 * 获取虚拟教研室的资源的图标的icon
 * @param ext
 */
 export function getVirtualResourceIcon(ext:string,type:number=0){
  if(ext == "" || ext == null){
    return ext;
  }
  ext = ext.trimStart();
  ext = ext.trimEnd();
  let lastExt = ".png";
  if(type == 1){
    lastExt = "_big.png";
  }
  if(ext == "mp4" || ext == "flv" || ext == "mov" || ext == "rm"
    || ext == "rmvb" || ext == "avi" || ext == "3gp" || ext == "wmv"
    || ext == "mkv" || ext == "ts" || ext == "webm" || ext == "mpg"
    || ext == "asf" || ext == "swf"){
    return require('@/assets/images/virtualteaching/icon/document/video'+lastExt);
  }
  if(ext == "ppt" || ext == "pptx"){
    return require('@/assets/images/virtualteaching/icon/document/ppt'+lastExt);
  }
  if(ext == "doc" || ext == "docx" || ext == "wps" || ext == "wpt" || ext == "rtf"){
    return require('@/assets/images/virtualteaching/icon/document/word'+lastExt);
  }
  if(ext == "pdf"){
    return require('@/assets/images/virtualteaching/icon/document/pdf'+lastExt);
  }
  if(ext == "et" || ext == "ett" || ext == "xlt" || ext == "xls" || ext == "xlsx"){
    return require('@/assets/images/virtualteaching/icon/document/word'+lastExt);
  }
  if(ext == "jpg" || ext == "jpeg" || ext == "bmp" || ext == "png" || ext == "gif"
    || ext == "psd" || ext == "tga" || ext == "pcx" || ext == "tif"){
    return require('@/assets/images/virtualteaching/icon/document/pic'+lastExt);
  }
  if(ext == "exe"){
    return require('@/assets/images/virtualteaching/icon/document/exe'+lastExt);
  }
  if(ext == "mind" || ext == "xmind"){
    return require('@/assets/images/virtualteaching/icon/document/mind'+lastExt);
  }
  if(ext == "zip" || ext == "rar" || ext == "gzip"){
    return require('@/assets/images/virtualteaching/icon/document/zip'+lastExt);
  }
  if(ext == "c" || ext == "c++" || ext == "java" || ext == "py" || ext == "lua" || ext == "css"){
    return require('@/assets/images/virtualteaching/icon/document/code'+lastExt);
  }
  if(ext == "mp3" || ext == "acc"){
    return require('@/assets/images/virtualteaching/icon/document/audio'+lastExt);
  }
  return require('@/assets/images/virtualteaching/icon/document/other'+lastExt);
}

//文件大小转为 KB  MB GB
export function formatSize(size:number,delimiter=''){
  let units = [
     'B',
     'KB',
     'MB',
     'GB',
     'TB',
     'PB',
 ];
 let i=0;
 for (i = 0; size >= 1024 && i < 5; i++)
   size /= 1024;
 return Math.round(size).toFixed(1) + delimiter + units [i];
}

//视频和音频的时长
export function formatTimeLen(sec:number,delimiter=''){
  if(sec<60){
    return sec+"秒";
  }
  let units = [
      '秒',
      '分钟',
      '小时',
  ];
  let i=0;
  for (i = 0; sec >= 60 && i < 2; i++)
  sec /= 60;
  let lastData = Math.round(sec).toFixed(1);
  return lastData + delimiter + units [i];
}

//虚拟教研室，通过资源类型，获取souceType类型
export function convertResourceTypeToSourceType(resourceType:any){
  let sourceType = SourceTypeEnum.NO_OFFICE_INFORMATION;
  if(resourceType == VrtResourceTypeEnum.HOMEWORK){
    sourceType = SourceTypeEnum.HOMEWORK;
  }else if(resourceType == VrtResourceTypeEnum.COURSEWARE){
    sourceType = SourceTypeEnum.NO_OFFICE_INFORMATION;
  }else if(resourceType == VrtResourceTypeEnum.INTERACT_COURSEWARE){
    sourceType = SourceTypeEnum.INTERACTIVE_COURSEWARE;
  }else if(resourceType == VrtResourceTypeEnum.TESTPAPER){
    sourceType = SourceTypeEnum.PAPER;
  }else if(resourceType == VrtResourceTypeEnum.TOPIC){
    sourceType = SourceTypeEnum.TOPIC;
  }else if(resourceType == VrtResourceTypeEnum.WEBLINK){
    sourceType = SourceTypeEnum.LINK;
  }else if(resourceType == VrtResourceTypeEnum.INTERACT_TESTPAPER){
    sourceType = SourceTypeEnum.INTERACTIVE;
  }else if(resourceType == VrtResourceTypeEnum.MOOC_WEBLINK){
    sourceType = SourceTypeEnum.NO_OFFICE_INFORMATION;
  }else if(resourceType == VrtResourceTypeEnum.MOOC_RESOURCE){
    sourceType = SourceTypeEnum.NO_OFFICE_INFORMATION;
  }
  return sourceType;
}

//动态的时间展示
export function getPublishTime(dateTimeStamp: any): string {
  if (dateTimeStamp == 0) {
    return ''
  }
  let minute = 60;
  let hour = minute * 60;
  let day = hour * 24;
  let halfamonth = day * 15;
  let month = day * 30;

  let now = new Date().getTime()/1000;
  let diffValue = now - dateTimeStamp
  if (diffValue < 0) {
    return ''
  }
  let monthC: number = Math.trunc(diffValue/month);
  let weekC: number = Math.trunc(diffValue / (7 * day));
  let dayC: number = Math.trunc(diffValue / day);
  let hourC: number = Math.trunc(diffValue / hour);
  let minC: number = Math.trunc(diffValue / minute);
  let result: string = ''
  if (monthC >= 1) {
    result = time_format_year_month_day_hour_min(dateTimeStamp);
  }
  else if (weekC >= 1) {
    result = time_format_year_month_day_hour_min(dateTimeStamp);
  }
  else if (dayC >= 1 && dayC <=7 ) {
    result = dayC + "天前";
  }else if (dayC > 7) {
    result = time_format_year_month_day_hour_min(dateTimeStamp);
  }else if (hourC >= 1) {
    result = hourC + "小时前";
  }else if (minC >= 1) {
    result = minC + "分钟前";
  }else if (diffValue < 60 && diffValue>15) {
    result = Math.floor(diffValue) + '秒前'
  }else{
    result = '刚刚'
  }
  return result;
}

//获取动态的资源列表
export function getIconBySourceType(dynamicItem:any){
  if(dynamicItem == null){
    return "";
  }
  let source = dynamicItem['source'];
  let dataInfo = dynamicItem['post_data'];
  if(source == SourceTypeEnum.DISCUSS_MEETING){
    return "";
  }
  if(source == SourceTypeEnum.DISCUSS_SUBJECT){
    return "";
  }
  if(source == SourceTypeEnum.DISCUSS_VIDEO){
    return "";
  }
  //资源，这里就很复杂
  if(source == SourceTypeEnum.NO_OFFICE_INFORMATION || source == SourceTypeEnum.TEMPLATE_COURSE_INFORMATION){
    if(dataInfo['fileType'] != null && dataInfo['fileType'] != undefined){
      if(dataInfo['fileType'] == "mooc"){
        let attachment = dataInfo['attachment'][0];
        if(attachment != null && attachment != undefined){
          return attachment['thumb_src'];
        }
      }else if(dataInfo['fileType'] == "mooc_web"){
        return require('@/assets/images/virtualteaching/icon/document/weblink.png');
      }
    }
    if(isPic(dataInfo['ext'])){
      return dataInfo['ext_echo'];
    }
    if(isPPT(dataInfo['ext'])){
      if(parseInt(dataInfo['length'])>0){
        return dataInfo['ext_echo'];
      }
      return dataInfo['ext_icon'];
    }else if(isWord(dataInfo['ext'])){
      if(parseInt(dataInfo['length'])>0){
        return dataInfo['ext_echo'];
      }
      return dataInfo['ext_icon'];
    }else if(isVideo(dataInfo['ext'])){
      if(parseInt(dataInfo['length'])>0){
        return dataInfo['ext_echo'];
      }
      return dataInfo['ext_icon'];
    }
    return dataInfo['ext_icon'];
  }
  //互动课件
  if(source == SourceTypeEnum.INTERACTIVE_COURSEWARE || source == SourceTypeEnum.TEMPLATE_COURSE_INTERACT_COURSEWARE){
    if(parseInt(dataInfo['length'])>0){
      return dataInfo['ext_echo'];
    }
    return dataInfo['ext_icon'];
  }
  if(source == SourceTypeEnum.PAPER){
    return require('@/assets/images/virtualteaching/icon/resourcetype/testpaper.png');
  }
  if(source == SourceTypeEnum.HOMEWORK){
    return require('@/assets/images/virtualteaching/icon/resourcetype/homework.png');
  }
  if(source == SourceTypeEnum.TOPIC){
    return require('@/assets/images/virtualteaching/icon/resourcetype/topic.png');
  }
  if(source == SourceTypeEnum.TEMPLATE_COURSE){
   if (dataInfo['theme']) {
    return dataInfo['theme']['middlepic'];
   }
  }
  if(source == SourceTypeEnum.TEMPLATE_COURSE_MOOC_INFORMATION){
    if(dataInfo['fileType'] != null && dataInfo['fileType'] != undefined){
      if(dataInfo['fileType'] == "mooc"){
        let attachment = dataInfo['attachment'][0];
        if(attachment != null && attachment != undefined){
          return attachment['thumb_src'];
        }
      }else if(dataInfo['fileType'] == "mooc_web"){
        return require('@/assets/images/virtualteaching/icon/document/weblink.png');
      }
    }
  }
  if(source == SourceTypeEnum.TEMPLATE_COURSE_TEST){
    return require('@/assets/images/virtualteaching/icon/resourcetype/testpaper.png');
  }
  //样本课的互动答题
  if(source == SourceTypeEnum.TEMPLATE_COURSE_ANSWER){
    return require('@/assets/images/virtualteaching/icon/resourcetype/interact.png');
  }
  if(source == SourceTypeEnum.TEMPLATE_COURSE_HOMEWORK){
    return require('@/assets/images/virtualteaching/icon/resourcetype/homework.png');
  }
  if(source == SourceTypeEnum.TEMPLATE_COURSE_ANNOUNCEMENT){
    return require('@/assets/images/virtualteaching/icon/resourcetype/annouce.png');
  }
  if(source == SourceTypeEnum.TEMPLATE_COURSE_TOPIC){
    return require('@/assets/images/virtualteaching/icon/resourcetype/topic.png');
  }
  if(source == SourceTypeEnum.ANNOUNCEMENT){
    return require('@/assets/images/virtualteaching/icon/resourcetype/annouce.png');
  }
  if(source == SourceTypeEnum.INTERACTIVE){
    return require('@/assets/images/virtualteaching/icon/resourcetype/interact.png');
  }
  if(source == SourceTypeEnum.LINK){
    return require('@/assets/images/virtualteaching/icon/resourcetype/weblink.png');
  }
  return require('@/assets/images/virtualteaching/icon/resourcetype/homework.png');
}

//给资源库的文件的类型进行索引处理
export function getResourceFileTypeIndex(ext:string){
  if(ext == "exe"){
      return 0;
  }
  if(ext == "zip" || ext == "rar" || ext == "gzip"){
      return 0;
  }
  if(ext == "mp4" || ext == "flv" || ext=="mov" || ext == "rm" || ext == "rmvb" || ext == "avi" || ext == "3gp" || ext == "wmv" || ext == "mkv" || ext == "ts" || ext == "webm" || ext == "mpg" || ext == "asf" || ext == "swf"){
     return 1;
  }
  if(ext == "ppt" || ext == "pptx"){
      return 2;
  }
  if(ext == "doc" || ext == "docx" || ext == "wps" || ext == "wpt" || ext == "rtf" || ext == "pdf"){
      return 2;
  }
  if(ext == "et" || ext == "ett" || ext == "xlt" || ext == "xls" || ext == "xlsx"){
      return 2;
  }
  if(ext == "mind" || ext == "xmind"){
      return 0;
  }
  if(ext == "c" || ext == "c++" || ext == "java" || ext == "py" || ext == "lua" || ext == "css"){
     return 2;
  }
  if(ext == "jpg" || ext == "jpeg" || ext == "bmp" || ext == "png" || ext == "gif" || ext == "psd" || ext == "tga" || ext == "pcx" || ext == "tif"){
      return 3;
  }
  if(ext == "mp3" || ext == "aac"){
      return 4;
  }
  return 0;
}

/**
 * 判断是不是PPT
 * @param ext
 * @returns
 */
 export function isPPT(ext: string) {
  if (ext == undefined || ext == null || ext == "") {
    return false;
  }
  let extTypeArray = [
    'ppt',
    'pptx',
  ];
  for (let i = 0; i < extTypeArray.length; i++) {
    if (extTypeArray[i] == ext.toLowerCase()) {
      return true;
    }
  }
  return false;
}

export function isWord(ext:string){
  if (ext == undefined || ext == null || ext == "") {
    return false;
  }
  let extTypeArray = [
    'doc',
    'docx',
    'pdf',
  ];
  for (let i = 0; i < extTypeArray.length; i++) {
    if (extTypeArray[i] == ext.toLowerCase()) {
      return true;
    }
  }
  return false;
}

export function isExcel(ext:string){
  if (ext == undefined || ext == null || ext == "") {
    return false;
  }
  let extTypeArray = [
    'xls',
    'xlsx',
  ];
  for (let i = 0; i < extTypeArray.length; i++) {
    if (extTypeArray[i] == ext.toLowerCase()) {
      return true;
    }
  }
  return false;
}

//虚拟教研室，通过动态里面的类型，获取资源库的类型
export function convertSourceTypeToResourceTypeByDynamicItem(dynamicItem:any){
  let sourceType = parseInt(dynamicItem['source']);
  let dataInfo = dynamicItem['post_data'];
  let resourceType = VrtResourceTypeEnum.COURSEWARE;
  if(sourceType == SourceTypeEnum.NO_OFFICE_INFORMATION){
    if(dataInfo['fileType'] != null && dataInfo['fileType'] != undefined){
      if(dataInfo['fileType'] == "mooc"){
        resourceType = VrtResourceTypeEnum.MOOC_RESOURCE;
      }else if(dataInfo['fileType'] == "mooc_web"){
        resourceType = VrtResourceTypeEnum.MOOC_WEBLINK;
      }else{
        resourceType = VrtResourceTypeEnum.COURSEWARE;
      }
    }else{
      resourceType = VrtResourceTypeEnum.COURSEWARE;
    }
  }else if(sourceType == SourceTypeEnum.LINK){
    resourceType = VrtResourceTypeEnum.WEBLINK;
  }else if(sourceType == SourceTypeEnum.HOMEWORK){
    resourceType = VrtResourceTypeEnum.HOMEWORK;
  }else if(sourceType == SourceTypeEnum.PAPER){
    resourceType = VrtResourceTypeEnum.TESTPAPER;
  }else if(sourceType == SourceTypeEnum.INTERACTIVE){
    resourceType = VrtResourceTypeEnum.INTERACT_TESTPAPER;
  }else if(sourceType == SourceTypeEnum.TOPIC){
    resourceType = VrtResourceTypeEnum.TOPIC;
  }else if(sourceType == SourceTypeEnum.INTERACTIVE_COURSEWARE){
    resourceType = VrtResourceTypeEnum.INTERACT_COURSEWARE;
  }
  return resourceType;
}
//获取会议时间
export function getConferenceTime(startTime:number,endTime:number){
  let diffTime = endTime-startTime;
  let timesStr1 = startTime + '';
  if (timesStr1.length == 10) {
    startTime = startTime * 1000;
  }
  var time1 = new Date(startTime);

  let timesStr2 = endTime + '';
  if (timesStr2.length == 10) {
    endTime = endTime * 1000;
  }
  var time2 = new Date(endTime);

  if(time1.getDate() == time2.getDate()){
    let secondTime = toDouble(time2.getHours()) + ":";
    secondTime += toDouble((time2.getMinutes()));
    return time_format_year_month_day_hour_min(startTime)+" ~ "+secondTime;
  }
  return time_format_year_month_day_hour_min(startTime)+" ~ "+time_format_year_month_day_hour_min(endTime);
}
//获取duration
export function getDurationTime(duration:number){
  duration = parseInt(duration+'');
  let remainSec = duration%60;
  let AllMinute = Math.trunc(duration/60);//分钟
  let remainMinute = AllMinute%60;//剩余的分钟数
  let AllHours = Math.trunc(AllMinute/60);//所有小时
  let lastStr = toDouble(AllHours)+":"+toDouble(remainMinute)+":"+toDouble(remainSec);
  return lastStr;
}
//处理打开新页面和当前页面时的关系存储
export function storeReferrerData(currentUrl:string,openUrl:string){
  let data = {
    'currentUrl':currentUrl,
    'openUrl':openUrl,
  };
  localStorage['referrer'] = JSON.stringify(data);
}
//获取referrerData
export function getStoreReferrerData(){
  let referrer = localStorage['referrer'];
  if(referrer != null && referrer != "" && referrer.length>0){
    let data = JSON.parse(referrer);
    return data;
  }
  return null;
}
// 返回min和max之间的一个随机数，包括min和max
export function getRandomInt(min:number, max:number) {
  return Math.floor(Math.random() * (max - min + 1) + min) // +1是保证可以取到上限值
}
//随机打乱数组内容
export function randDataArray(arr:[]){
  if(arr == null || arr.length == 0){
    return arr;
  }
  let _arr = arr.slice()   // 下面会讲到slice的特别之处
  for (let i = 0; i < _arr.length; i++) {
    let j = getRandomInt(0, i)
    let t = _arr[i]
    _arr[i] = _arr[j]
    _arr[j] = t
  }
  return _arr;
}

/**
 * 获取动态的小 icon
 * @param dynamicItem
 * @returns
 */
export function getDynamicIcon(dynamicItem:any){
  if(dynamicItem == null){
    return "";
  }
  let source = dynamicItem['source'];
  let dataInfo = dynamicItem['post_data'];
  if(source == SourceTypeEnum.DISCUSS_MEETING){
    return require('@/assets/images/virtualteaching/icon/document/conference.png');
  }
  if(source == SourceTypeEnum.DISCUSS_SUBJECT){
    return require('@/assets/images/virtualteaching/icon/document/discuss_topic.png');
  }
  if(source == SourceTypeEnum.DISCUSS_VIDEO){
    return require('@/assets/images/virtualteaching/icon/document/video.png');
  }
  //资源，这里就很复杂
  if(source == SourceTypeEnum.NO_OFFICE_INFORMATION || source == SourceTypeEnum.TEMPLATE_COURSE_INFORMATION || source == SourceTypeEnum.TEMPLATE_COURSE_MOOC_INFORMATION){
    if(dataInfo['fileType'] != null && dataInfo['fileType'] != undefined){
      if(dataInfo['fileType'] == "mooc"){
        return require('@/assets/images/virtualteaching/icon/document/pic.png');
      }else if(dataInfo['fileType'] == "mooc_web"){
        return require('@/assets/images/virtualteaching/icon/document/weblink_small.png');
      }
    }
    if(isPic(dataInfo['ext'])){
      return require('@/assets/images/virtualteaching/icon/document/pic.png');
    }
    if(isPPT(dataInfo['ext'])){
      return require('@/assets/images/virtualteaching/icon/document/ppt.png');
    }else if(isWord(dataInfo['ext'])){
      return require('@/assets/images/virtualteaching/icon/document/word.png');
    }else if(isVideo(dataInfo['ext'])){
      return require('@/assets/images/virtualteaching/icon/document/video.png');
    }
    return require('@/assets/images/virtualteaching/icon/document/other.png');
  }
  //互动课件
  if(source == SourceTypeEnum.INTERACTIVE_COURSEWARE || source == SourceTypeEnum.TEMPLATE_COURSE_INTERACT_COURSEWARE){
    return require('@/assets/images/virtualteaching/icon/document/ppt.png');
  }
  if(source == SourceTypeEnum.PAPER){
    return require('@/assets/images/virtualteaching/icon/document/test.png');
  }
  if(source == SourceTypeEnum.HOMEWORK){
    return require('@/assets/images/virtualteaching/icon/document/homework.png');
  }
  if(source == SourceTypeEnum.TOPIC){
    return require('@/assets/images/virtualteaching/icon/document/resource_topic.png');
  }
  if(source == SourceTypeEnum.TEMPLATE_COURSE){
    return require('@/assets/images/virtualteaching/icon/document/pic.png');
  }
  if(source == SourceTypeEnum.TEMPLATE_COURSE_TEST){
    return require('@/assets/images/virtualteaching/icon/document/testpaper.png');
  }
  //样本课的互动答题
  if(source == SourceTypeEnum.TEMPLATE_COURSE_ANSWER){
    return require('@/assets/images/virtualteaching/icon/document/interact.png');
  }
  if(source == SourceTypeEnum.TEMPLATE_COURSE_HOMEWORK){
    return require('@/assets/images/virtualteaching/icon/document/homework.png');
  }
  if(source == SourceTypeEnum.TEMPLATE_COURSE_ANNOUNCEMENT){
    return require('@/assets/images/virtualteaching/icon/document/annouce.png');
  }
  if(source == SourceTypeEnum.TEMPLATE_COURSE_TOPIC){
    return require('@/assets/images/virtualteaching/icon/document/resource_topic.png');
  }
  if(source == SourceTypeEnum.ANNOUNCEMENT){
    return require('@/assets/images/virtualteaching/icon/document/annouce.png');
  }
  if(source == SourceTypeEnum.INTERACTIVE){
    return require('@/assets/images/virtualteaching/icon/document/interact.png');
  }
  if(source == SourceTypeEnum.LINK){
    return require('@/assets/images/virtualteaching/icon/document/weblink_small.png');
  }
  return require('@/assets/images/virtualteaching/icon/document/homework.png');
}

/**
 * 获取动态的标题
 * @param dynamicItem
 */
export function getDynamicTitle(dynamicItem:any){
  let source = dynamicItem['source'];
  let dataInfo = dynamicItem['post_data'];
  if(source == SourceTypeEnum.DISCUSS_MEETING){
    return dataInfo['content']['title'];
  }
  if(source == SourceTypeEnum.DISCUSS_SUBJECT){
    return dataInfo['content']['title'];
  }
  if(source == SourceTypeEnum.DISCUSS_ARTICLE){
    return dataInfo['content']['title'];
  }
  if(source == SourceTypeEnum.DISCUSS_VIDEO){
    return dataInfo['content']['title'];
  }
  let title = dataInfo['filename'];
  if(dataInfo['filename'] == null || dataInfo['filename'] == undefined || dataInfo['filename'] == ""){
    title = dataInfo['title'];
  }
  if(title != "" && title != null && title != undefined){
    return title;
  }
  if(dataInfo['coursename'] != ""){
    return dataInfo['coursename'];
  }
}
/**
 * 虚拟教研室权限验证
 * @param role 原对象
 * @return 返回boolean
 */
 export function virtualPurviewSetting(role: string) {
  if (role) {
    switch (role) {
      case '1':
        return true
      case '2':
        return true
      case '3':
        return false
      case '4':
        return false
    }
  }
}
// 解析 元素的innerHTML内容即为转义后的字符
export function htmlDecode(str: string) {
  let ele = document.createElement('span')
  ele.innerHTML = str
  return ele.textContent
}

export const sleep = (time: number) => {
    return new Promise((resolve) => setTimeout(resolve, time));
}

/**
 * 获取图片base64
 * @param {string} url 图片路径
 * @param {'jpg'|'png'} type 图片格式（可选）
 */
export function getBase64(url: string, type = 'png') {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
  const img = new Image();

  img.crossOrigin = 'Anonymous';
  img.src = url;

  return new Promise((resolve, reject) => {
    img.onload = function () {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const base64 = canvas.toDataURL('image/' + type);
      resolve(base64);
    }

    img.onerror = function () {
      reject()
    }
  })
}

//判断是不是 andorid
export function isAndroids() {
  var agent = navigator.userAgent.toLowerCase();
  var android = agent.indexOf("android");
  var iphone = agent.indexOf("iphone");
  var ipad = agent.indexOf("ipad");
  if(android != -1){
      return true;
  }
  if(iphone != -1 || ipad != -1){
     return false;
  }
  return false;
}

//是否可以展示 付费课程的内容
export function isCanShowAdCourse(myshool:string){
  if(myshool == "" || myshool == undefined || myshool == null){
    return true;
  }
  //在名单里面的学校不展示广告课程
  let whiteSchoolLists = [
    "北京大学"
  ];
  let isInWhiteLists = false;
  for(let i=0;i<whiteSchoolLists.length;i++){
    let tmp = whiteSchoolLists[i];
    if( myshool != null && myshool.indexOf(tmp)>-1){
      isInWhiteLists = true;
      return false;//不允许展示广告课程
    }
  }
  //过滤掉小学和中学
  if(isInWhiteLists == false){
    if( myshool != null && (myshool.indexOf("中学")>-1 || myshool.indexOf("高中")>-1 || myshool.indexOf("小学")>-1)){
      isInWhiteLists = true;
      return false;//不允许展示广告课程
    }
  }
  return true;
}

/**
 * 判断是不是 英语的语言
 */
 export function isEnLang(){
  let lang = localStorage.getItem('xlanguage');
  if(lang == "en"){
    return true;
  }
  return false;
}

/**
 * 获取考勤状态的名称
 * @param state
 */
export function getAttenceStateTitle(state:number){
  if(state == AttenceStateEnum.ATTENCE){
    return i18n.t('Attendance.status.出勤');
  }
  if(state == AttenceStateEnum.ABSENCE){
    return i18n.t('Attendance.status.缺勤');
  }
  if(state == AttenceStateEnum.LATE){
    return i18n.t('Attendance.status.迟到');
  }
  if(state == AttenceStateEnum.PLEASE){
    return i18n.t('Attendance.status.请假');
  }
  if(state == AttenceStateEnum.PRIVATE_LEAVE){
    return i18n.t('Attendance.status.事假');
  }
  if(state == AttenceStateEnum.SICK_LEAVE){
    return i18n.t('Attendance.status.病假');
  }
  if(state == AttenceStateEnum.STATUTORY){
    return i18n.t('Attendance.status.公假');
  }
  if(state == AttenceStateEnum.LEAVE_EARLY){
    return i18n.t('Attendance.status.早退');
  }
  if(state == AttenceStateEnum.WAIT_CHECK_IN){
    return i18n.t('Attendance.status.待签到');
  }
}

//获取二级域名
export function getsecondDomain() {
  let href = location.href;
  let secondDomainWithProtocal = href.split(".")[0];
  let secondDomain = secondDomainWithProtocal.split("//")[1];
  return secondDomain;
}

//判断是不是课堂派的主域名，不是个性化域名
export function isKtpSelfDoamin() {
  if(location.hostname.includes('ketangpai.com') || location.hostname.includes('ketangpai.cn')) {
    return true;
  }
  return false;
}

/**
 * 加载百度广告
 * @param id
 * @param container
 */
export function loadBaiduAd(id:string,container:string){
  //只有在课堂派的域名下才能进行广告的处理
  if(!isKtpSelfDoamin()){
    return;
  }
  // //@ts-ignore
  // (window.slotbydup = window.slotbydup || []).push({
  //     id: id,
  //     container: container,
  //     async: true
  // });
}

export function htmlEncode(html:string){
  //1.首先动态创建一个容器标签元素，如DIV
  let  temp = document.createElement ("div");
 //2.然后将要转换的字符串设置为这个元素的innerText(ie支持)或者textContent(火狐，google支持)
  (temp.textContent != undefined ) ? (temp.textContent = html) : (temp.innerText = html);
  //3.最后返回这个元素的innerHTML，即得到经过HTML编码转换的字符串了
  var output = temp.innerHTML;
  //@ts-ignore
  temp = null;
  return output;
}

/**
 * 课程权限的判断
 * @param moduleName
 * @returns
 */
export function isCourseAuth(moduleName:string){
  let courseid = getUrlQueryUseHash("courseId");
  let courseAuthName:string = "courseAuth:"+courseid;
  const courseAuthStr = objCookie.getCookie(courseAuthName) as string;
  if(courseAuthStr == null || courseAuthStr == ""){
    return true;
  }
  const courseAuth = JSON.parse(courseAuthStr);
  if(courseAuth == null){
    return true;
  }
  if(courseAuth.courseAdmin == 1){
    return true;
  }
  let authLists = courseAuth.auth;
  if(authLists == null){
    return true;
  }
  for(let i=0;i<authLists.length;i++){
    let element = authLists[i];
    if(element == moduleName){
      return true;
    }
  }
  return false;
}

/**
 * 私有化部署时隐藏一些功能点时，可以使用该指令
 */
export function hidePrivateDeployModule(){
  if(urlConfig.privateDeploy == true){
    return true;
  }
  return false;
}

/**
 * 获取视频类型的列表
 * @returns
 */
export function getVideoExtLists(){
  let videoType :Array<string> = ['mp4', 'flv', 'mov', 'rm', 'rmvb', 'avi', '3gp', 'wmv', 'mkv', 'ts', 'webm', 'm3u8', 'mpg', 'asf', 'flash', 'swf'];
  return videoType;
}

export function base64ToUtf8(str: string): string {
  return decodeURIComponent(escape(window.atob(str)));
}
